"use strict";

var _typeof = require("@babel/runtime-corejs2/helpers/typeof");

var _WeakMap = require("@babel/runtime-corejs2/core-js/weak-map");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _useI18n = _interopRequireDefault(require("@paprika/l10n/lib/useI18n"));

var _helpers = require("@paprika/helpers");

var _Link = _interopRequireDefault(require("./components/Link"));

var _ExpandButton = _interopRequireDefault(require("./components/ExpandButton"));

var _context = _interopRequireDefault(require("./context"));

var _constants = require("./constants");

var sc = _interopRequireWildcard(require("./Breadcrumbs.styles"));

var _excluded = ["children", "isDark", "isAutoCollapsed"];

function _getRequireWildcardCache(nodeInterop) { if (typeof _WeakMap !== "function") return null; var cacheBabelInterop = new _WeakMap(); var cacheNodeInterop = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { _Object$defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function Breadcrumbs(props) {
  var children = props.children,
      isDark = props.isDark,
      isAutoCollapsed = props.isAutoCollapsed,
      moreProps = (0, _objectWithoutProperties2["default"])(props, _excluded);
  var I18n = (0, _useI18n["default"])();
  var linkChildren = [(0, _helpers.extractChildren)(children, ["Breadcrumbs.Link"])["Breadcrumbs.Link"]].flat();
  var hasOnlyOneChild = linkChildren.length === 1;
  var shouldShowExpandButton = isAutoCollapsed && linkChildren.length > _constants.MAXIMUM_NUM_OF_LEVEL;

  var _React$useState = _react["default"].useState(shouldShowExpandButton),
      _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
      isCollapsed = _React$useState2[0],
      setIsCollapsed = _React$useState2[1];

  _react["default"].useLayoutEffect(function () {
    setIsCollapsed(shouldShowExpandButton);
  }, [shouldShowExpandButton]);

  function handleExpand() {
    setIsCollapsed(false);
  }

  return /*#__PURE__*/_react["default"].createElement(_context["default"].Provider, {
    value: isDark
  }, /*#__PURE__*/_react["default"].createElement(sc.Nav, (0, _extends2["default"])({
    "aria-label": I18n.t("breadcrumbs.aria_label"),
    isDark: isDark
  }, moreProps), /*#__PURE__*/_react["default"].createElement(sc.List, {
    isCollapsed: isCollapsed
  }, linkChildren.map(function (child, index) {
    if (shouldShowExpandButton && index === 0) {
      return (
        /*#__PURE__*/
        // eslint-disable-next-line react/no-array-index-key
        _react["default"].createElement(_react["default"].Fragment, {
          key: index
        }, child, /*#__PURE__*/_react["default"].createElement(_ExpandButton["default"], {
          onClick: handleExpand,
          isHidden: !isCollapsed
        }))
      );
    } // eslint-disable-next-line react/no-array-index-key


    return /*#__PURE__*/_react["default"].cloneElement(child, {
      hasOnlyOneChild: hasOnlyOneChild,
      key: index
    });
  }))));
}

var propTypes = {
  children: _propTypes["default"].node,

  /** If the breadcrumbs will be rendered on a dark background and will use inverted colours. */
  isDark: _propTypes["default"].bool,

  /** If the breadcrumbs will be collapsed when it has more than 3 links. */
  isAutoCollapsed: _propTypes["default"].bool
};
var defaultProps = {
  children: null,
  isDark: false,
  isAutoCollapsed: true
};
Breadcrumbs.displayName = "Breadcrumbs";
Breadcrumbs.propTypes = propTypes;
Breadcrumbs.defaultProps = defaultProps;
Breadcrumbs.Link = _Link["default"];
var _default = Breadcrumbs;
exports["default"] = _default;
//# sourceMappingURL=Breadcrumbs.js.map